// ExistingClients.js
// UNVERIFIED: the client portal link below was repointed from the cloned site's
// domain to app.ivipass.com. Nobody has confirmed that this subdomain exists or
// that a client portal is live. Check it resolves, or remove this section.
import React from 'react';
import { motion } from 'framer-motion';
import { LogIn } from 'lucide-react';

const ExistingClients = () => {
  return (
    <section className="py-16 bg-surface">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="max-w-3xl mx-auto">
          {/* Section Header */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-8"
          >
            <h2 className="text-3xl md:text-4xl font-semibold text-primary mb-4">
              Already a Client?
            </h2>
            <p className="text-gray-600 text-base font-light leading-relaxed">
              Anyone already working with Ivipass can sign in to the portal to check on progress, send documents across, or message the advisor handling their case.
            </p>
          </motion.div>

          {/* Portal Login Button */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-center"
          >
            <a
              href="https://app.ivipass.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-secondary hover:bg-secondary-hover text-white font-normal text-base px-8 py-4 rounded-lg transition-colors"
            >
              Client Portal Login
              <LogIn size={20} />
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ExistingClients;
